import localforage from 'localforage';
import { set, upperFirst } from 'lodash';
import { encrypt, decrypt } from './crypt';

const types = {
  token: 31536000000,
};

class Storage {
  constructor() {
    Object.keys(types).forEach(key => {
      const name = upperFirst(key);
      set(this, `set${name}`, payload => this.set(key, payload));
      set(this, `get${name}`, () => this.get(key));
      set(this, `remove${name}`, () => this.remove(key));
    });
  }

  set(key, payload) {
    return localforage.setItem(key, {
      data: encrypt(payload),
      date: new Date().getTime(),
    });
  }

  async get(key) {
    const result = await localforage.getItem(key);
    if (!result) return null;

    const { data, date } = result;
    // console.warn('TODO: do something with storage data and ttl', date);
    if (!data) return null;

    /*const test = decrypt(data);
    return test;
    */
    return decrypt(data);
  }

  remove(key) {
    return localforage.removeItem(key);
  }
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/util/storage.js